import { cn } from "@/shared/lib/utils";
import * as React from "react";
import { forwardRef } from "react";

export interface ISectionLayoutProps
  extends React.ComponentPropsWithoutRef<'section'> {
    children: React.ReactNode,
    containerClassName?: string 
  }

export const SectionLayout = forwardRef<HTMLElement, ISectionLayoutProps>(
    ({ children, className, containerClassName, style }, ref) => {
        return (
            <section className={cn(
                'w-full bg-cover bg-no-repeat bg-center',
                className
            )} ref={ref} style={style}>
                <div className={cn(
                    'container',
                    containerClassName
                )}>
                    {children}
                </div>
            </section>
        );
    }
);

SectionLayout.displayName = "SectionLayout";
